export class LinkHelper {

  /**
   * Returns safe URL or adds http to beginning.  Returns empty string if unsafe URL.
   * @param url URL to test
   * @returns
   */
  public static verifyLink(url: string): string {
    let href = url;
    if (!href.toLowerCase().startsWith('http://') && !href.toLowerCase().startsWith('https://')) {
      href = `http://${href}`;
    }
    try {
      const parsed = new URL(href);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        return '';
      }
      return parsed.href;
    } catch {
      return '';
    }
  }

}
